'use client';

import * as config from './lib';

export { config };

export * from './context/ComponentConfigContext';
export * from './components';

export type ConfiguredComponents = keyof typeof config;
